(() => {
  'use strict';
  if (!document.body.classList.contains('template-index')) return;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initHero(root) {
    if (root.dataset.homeReady) return;
    root.dataset.homeReady = 'true';
    const video = root.querySelector('video');
    const toggle = root.querySelector('[data-home-video-toggle]');
    if (!video || !toggle) return;
    let userPaused = motion.matches;
    let inView = true;
    const label = toggle.querySelector('[data-home-video-label]');
    const icon = toggle.querySelector('[data-home-video-icon]');
    const sync = () => {
      const text = video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
      toggle.setAttribute('aria-label', text);
      label.textContent = text;
      icon.textContent = video.paused ? '▷' : 'Ⅱ';
    };
    const updatePlayback = () => {
      if (userPaused || !inView || document.hidden) video.pause();
      else video.play().catch(sync);
      sync();
    };
    toggle.hidden = false;
    toggle.addEventListener('click', () => {
      userPaused = !video.paused;
      updatePlayback();
    });
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    document.addEventListener('visibilitychange', updatePlayback);
    motion.addEventListener('change', () => {
      userPaused = motion.matches;
      updatePlayback();
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting;
        updatePlayback();
      }, { threshold: 0.05 });
      observer.observe(root);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) {
          observer.disconnect();
          document.removeEventListener('visibilitychange', updatePlayback);
        }
      });
    }
    updatePlayback();
  }
  function init(context = document) {
    context.querySelectorAll('[data-home-hero]').forEach(initHero);
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
